import React from 'react';
import classnames from 'classnames';
import LayoutBlock from '@fiverr-private/cms_ui/src/content_types/LayoutBlock/component/LayoutBlock';
import GigsCarousel from '@fiverr-private/cms_ui/src/content_types/GigsCarousel/component/GigsCarousel';
import { CONTENT_MODEL_TYPES } from '@fiverr-private/cms_ui/src/helpers/constants';
import { CustomError } from '@fiverr-private/cms_ui/src/helpers/modelHelpers';
import { useCSR, handleSSRError } from '@fiverr-private/cms_ui/src/content_types/CMSProvider';

import './index.scss';

const Items = {
    [CONTENT_MODEL_TYPES.GIGS_CAROUSEL]: GigsCarousel,
    [CONTENT_MODEL_TYPES.LAYOUT_BLOCK]: LayoutBlock,
    [CONTENT_MODEL_TYPES.IFRAME]: () => null
};

const getRenderedItem = (item) => {
    const RenderedItem = Items[item.type];

    if (!RenderedItem) {
        throw new CustomError(`Unknown type {${item.type}} of contentBlock, expected one of [${Object.keys(Items).join(', ')}]`);
    }

    return <RenderedItem key={item.id} {...item}/>;
};

const LandingPage = (props) => {
    const { loading, componentData: { theme, contentBlocks } } = useCSR(props);
    if (loading) { return null; }
    const classes = classnames('cms_ui-package', 'cms-page', 'max-width-container', theme);

    return (
        <div className={classes}>
            {contentBlocks.map((item) => getRenderedItem(item))}
        </div>
    );
};

export default handleSSRError(LandingPage);
